import { Module } from 'wrapper6'
import anime from 'animejs'

export default class Modal extends Module {
  ready() {
    const body = document.body
    let closing = false

    /**
     * Close modals
     */
    const modalOuters = document.querySelectorAll('.modal-outer')
    const closeBtns = document.querySelectorAll('.modal-outer .close-modal')

    for (let i = 0; i < closeBtns.length; i++) {
      const close = closeBtns[i]
      const modal = jQuery(closeBtns[i]).closest('.modal-outer')[0]

      // close modal on button close
      close.addEventListener('click', () => {
        closeModal()
      })

      // close modal on when clicking outside modal
      modal.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal-outer')) {
          closeModal()
        }
      })
    }

    for (let i = 0; i < modalOuters.length; i++) {
      const modalOuter = modalOuters[i]
      modalOuter.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal-outer')) {
          closeModal()
        }
      })
    }

    const closeButtons = '.close-button'

    jQuery(document).on('click', closeButtons, function () {
      closeModal()
    })

    // close modal on escape
    document.onkeydown = function (evt) {
      evt = evt || window.event

      if (evt.keyCode === 27 && body.classList.contains('modal-open')) {
        closeModal()
      }
    }

    /**
     * Functions
     */

    function openModal(modal) {
      anime({
        targets: modal.children[0],
        opacity: [0, 1],
        duration: 300,
        easing: 'easeOutCubic',
        delay: 200
      })

      body.classList.add('modal-open')
      modal.classList.add('active')
    }

    function closeModal() {
      if (closing) return false

      closing = true

      setTimeout(() => {
        closing = false
      }, 1000)

      const modal = document.querySelector('.modal-outer.active')

      body.classList.remove('modal-open')

      anime({
        targets: '.modal-inner',
        opacity: [1, 0],
        duration: 300,
        easing: 'easeOutCubic'
      })

      setTimeout(function () {
        modal.classList.remove('active')
      }, 300)

      const modalevent = document.createEvent('Event')
      modalevent.initEvent('modalclosed', true, true)
      modal.dispatchEvent(modalevent)
    }

    window.closeModal = closeModal // Make method available in global scope
    window.openModal = openModal // Make method available in global scope
  }
}
